import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import store from './store'
import router from './router'

import mitt from 'mitt'
const emitter = mitt();

const app = createApp(App)
    .use(Quasar, quasarUserOptions)
    .use(router)
    .use(createStore(store))
    // .use(VueBlocksTree, blocksTreeDefaultOptions)
    // .use(GAuth, gAuthOptions)

// app.config.globalProperties.connection = new Connection(emitter)
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.credentials = null;
app.mount('#app');
